/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ComunicazioneEmailInvioDTO { 
    id?: string;
    /**
     * Comune mittente e di perimetro; assente = mittente di piattaforma.
     */
    comune_id?: string;
    /**
     * Nome del comune mittente; assente = mittente di piattaforma.
     */
    mittente_comune_nome?: string;
    /**
     * Oggetto come scritto dall\'operatore (segnaposto non sostituiti); assente dopo la scadenza della conservazione (vedi testo_rimosso_at).
     */
    oggetto?: string;
    stato?: ComunicazioneEmailInvioDTOStatoEnum;
    /**
     * Cittadini scelti, compresi quelli senza email.
     */
    destinatari_totali?: number;
    inviati?: number;
    falliti?: number;
    saltati_senza_email?: number;
    /**
     * Destinatari per cui non si sa se l\'email e\' partita (invio interrotto da un riavvio o esito non registrato): da verificare prima di rilanciare.
     */
    esiti_ignoti?: number;
    allegati_count?: number;
    allegati_bytes?: number;
    /**
     * Motivo, a vocabolario chiuso: nessun_destinatario_con_email, nessun_invio_riuscito, coda_piena, avvio_non_riuscito, smtp_non_raggiungibile (anche su COMPLETATO: invio fermato a meta\'), errore_imprevisto, interrotto_da_riavvio. Assente se l\'invio e\' andato a termine.
     */
    errore?: string;
    created_at?: string;
    completato_at?: string;
    /**
     * Fino a quando oggetto e corpo restano nello storico; assente se gia\' rimossi.
     */
    testo_disponibile_fino?: string;
    /**
     * Quando oggetto e corpo sono stati rimossi per scadenza della conservazione; assente se ancora presenti.
     */
    testo_rimosso_at?: string;
    /**
     * Id dell\'operatore che ha lanciato l\'invio.
     */
    actor_user_id?: string;
    /**
     * Email dell\'operatore al momento dell\'invio; presente solo per il SUPERADMIN, mai per un OP_COMUNE (per lui vale mittente_nome).
     */
    actor_snapshot?: string;
    /**
     * Nome e cognome dell\'operatore che ha lanciato l\'invio.
     */
    mittente_nome?: string;
}
export enum ComunicazioneEmailInvioDTOStatoEnum {
    IN_CORSO = 'IN_CORSO',
    COMPLETATO = 'COMPLETATO',
    FALLITO = 'FALLITO',
    INTERROTTO = 'INTERROTTO'
};



